<header>
  <div class="left">
    <img src="../../../assets/logo.svg" />
    <select name="features-select" id="features-select">
      <option value="" selected>
        <img src="../../../assets/icon-todo.svg" />
        <span>Features</span>
      </option>
      <option value="todoList">
        <img src="../../../assets/icon-todo.svg" />
        <span>Todo List</span>
      </option>
      <option value="calendar">
        <img src="../../../assets/icon-calendar.svg" />
        <span>Calendar</span>
      </option>
      <option value="reminders">
        <img src="../../../assets/icon-reminders.svg" />
        <span>Reminders</span>
      </option>
      <option value="planning">
        <img src="../../../assets/icon-planning.svg" />
        <span>Planning</span>
      </option>
    </select>
    <select name="company-select" id="company-select">
      <option value="" selected>
        <span>Company</span>
      </option>
      <option value="history">
        <span>History</span>
      </option>
      <option value="ourTeam">
        <span>Our Team</span>
      </option>
      <option value="blog">
        <span>Blog</span>
      </option>
    </select>
    <a href="#">Careers</a>
    <a href="#">About</a>
  </div>
  <div class="right">
    <a href="#">Login</a>
    <a href="#">Register</a>
  </div>
</header>
